import React from 'react';

export interface Cheese3Props {
  className?: string;
  style?: React.CSSProperties;
  color?: string;
}

export const Cheese3: React.FC<Cheese3Props> = ({ className, style, color }) => {
  return (
    <svg
      width="84.557617"
      height="66.197266"
      viewBox="0 0 84.5576 66.1973"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
      style={style}
    >
      <defs />
      <g style={{ mixBlendMode: 'normal' }}>
        <path
          id="Tracé 60"
          d="M42.26 1C19.12 1 1 11.07 1 23.92L1 42.26C1 55.12 19.12 65.19 42.26 65.19C53.04 65.19 63.21 62.95 70.9 58.88C71.65 58.49 72.12 57.71 72.12 56.86L72.12 44.56L81.24 44.56C82.51 44.56 83.53 43.53 83.53 42.26L83.53 24.1C83.54 24.04 83.55 23.98 83.55 23.92C83.55 23.81 83.55 23.71 83.53 23.6C83.23 10.9 65.21 1 42.26 1ZM42.26 5.58C60.6 5.58 76.31 12.72 78.65 21.63L42.26 21.63C41.21 21.63 40.29 22.35 40.04 23.37C39.79 24.39 40.26 25.46 41.19 25.95L64.65 38.37C58.24 40.9 50.46 42.26 42.26 42.26C22.38 42.26 5.58 33.86 5.58 23.92C5.58 13.98 22.38 5.58 42.26 5.58ZM67.53 55.45C60.65 58.78 51.74 60.61 42.26 60.61C22.38 60.61 5.58 52.21 5.58 42.26L5.58 34.58C12.38 41.93 26.09 46.85 42.26 46.85C51.54 46.85 60.35 45.19 67.53 42.13L67.53 55.45ZM78.95 39.97L72.12 39.97L72.12 38.51C72.12 38.32 72.09 38.13 72.04 37.95C72.03 37.9 72.01 37.86 72 37.81C71.95 37.67 71.9 37.54 71.82 37.41C71.8 37.37 71.78 37.34 71.76 37.3C71.66 37.14 71.55 37 71.42 36.87C71.3 36.77 71.1 36.61 70.96 36.54L51.5 26.22L78.95 26.22L78.95 39.97L72.12 39.97Z"
          fill={color || "#F9A21F"}
          fillOpacity={1}
          fillRule="nonzero"
        />
        <path
          id="Tracé 60"
          d="M1 23.92L1 42.26C1 55.12 19.12 65.19 42.26 65.19C53.04 65.19 63.21 62.95 70.9 58.88C71.65 58.49 72.12 57.71 72.12 56.86L72.12 44.56L81.24 44.56C82.51 44.56 83.53 43.53 83.53 42.26L83.53 24.1C83.54 24.04 83.55 23.98 83.55 23.92C83.55 23.81 83.55 23.71 83.53 23.6C83.23 10.9 65.21 1 42.26 1C19.12 1 1 11.07 1 23.92ZM78.65 21.63L42.26 21.63C41.21 21.63 40.29 22.35 40.04 23.37C39.79 24.39 40.26 25.46 41.19 25.95L64.65 38.37C58.24 40.9 50.46 42.26 42.26 42.26C22.38 42.26 5.58 33.86 5.58 23.92C5.58 13.98 22.38 5.58 42.26 5.58C60.6 5.58 76.31 12.72 78.65 21.63ZM42.26 60.61C22.38 60.61 5.58 52.21 5.58 42.26L5.58 34.58C12.38 41.93 26.09 46.85 42.26 46.85C51.54 46.85 60.35 45.19 67.53 42.13L67.53 55.45C60.65 58.78 51.74 60.61 42.26 60.61ZM72.12 39.97L72.12 38.51C72.12 38.32 72.09 38.13 72.04 37.95C72.03 37.9 72.01 37.86 72 37.81C71.95 37.67 71.9 37.54 71.82 37.41C71.8 37.37 71.78 37.34 71.76 37.3C71.66 37.14 71.55 37 71.42 36.87C71.3 36.77 71.1 36.61 70.96 36.54L51.5 26.22L78.95 26.22L78.95 39.97L72.12 39.97Z"
          stroke={color || "#F9A21F"}
          strokeOpacity={1}
          strokeWidth={2}
        />
      </g>
    </svg>
  );
};

